
import companyAdminApi from 'app/apis/company-admin';

const Types = {
  SEARCH: 'CADMIN_MATCH_INQS_SEARCH',
};

const Actions = {

  search: (companyId, params) => {
    const promise = companyAdminApi.matchInquiriesSearch(companyId, params);
    return { type: Types.SEARCH, promise };
  },

};

export {
  Types,
};

export default Actions;
